import Explainer from '../blocks';
import gsap from 'gsap';

import styles from './CompetitiveEdge.module.css';

const EXPLAINER_WIDTH = 662;
const EXPLAINER_HEIGHT = 460;

const CompetitiveEdge = () => {
  const onInView = (inView) => {
    if (inView) {
      gsap.to('#ce-counter', {
        textContent: 99.98,
        duration: 2,
        snap: { textContent: 0.01 },
      });
    }
  };

  return (
    <Explainer
      width={EXPLAINER_WIDTH}
      height={EXPLAINER_HEIGHT}
      className={styles.root}
      onInView={onInView}
    >
      <g clipPath="url(#clip0_4024_11626)">
        <rect width="662" height="460" fill="#F0E5FF" />
        <rect
          opacity="0.5"
          x="133.424"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="143.23"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="133.424"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="252.949"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="252.949"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="252.949"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="242.531"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="242.531"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="232.725"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="222.912"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="222.912"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="222.912"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="43.3184"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="33.5137"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="43.3184"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="73.3555"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="123.006"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="123.006"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="123.006"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="143.23"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="153.043"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="162.85"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="222.912"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="222.912"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="3.48047"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="103.393"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="-6.32617"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="252.949"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="242.531"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="242.531"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="252.949"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="252.949"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="332.635"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="342.441"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="332.635"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="332.635"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="342.441"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="342.441"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="342.441"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="352.25"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="352.25"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="352.25"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="362.057"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="342.441"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="342.441"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="332.635"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="332.635"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="332.635"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="332.635"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="332.635"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="312.406"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="302.6"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="292.793"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="342.441"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="322.213"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="352.25"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="362.057"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="352.25"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="332.635"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="342.441"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="352.25"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="362.057"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="401.895"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="401.895"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="412.316"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="382.279"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="422.125"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="431.932"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="422.125"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="431.932"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="441.736"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="452.154"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="461.967"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="461.967"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="471.773"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="471.773"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="481.58"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="481.58"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="492.004"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="501.807"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="511.611"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="511.611"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="511.611"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="511.611"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="531.842"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="541.648"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="551.455"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="541.648"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="372.475"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="372.475"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="362.057"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="362.057"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="352.25"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="362.057"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="352.25"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="362.057"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="352.25"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="362.057"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="362.057"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="372.475"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="372.475"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="571.686"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="571.686"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="372.475"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="372.475"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="372.475"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="372.475"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="412.316"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="492.004"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="501.807"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="330.801"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="422.125"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="360.222"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="350.417"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="511.611"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="531.842"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="382.279"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="380.45"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="401.895"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="392.092"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="571.686"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="661.174"
          y="310.575"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="320.382"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="300.768"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="280.538"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="290.959"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="200.856"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="601.105"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="591.299"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="631.137"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="621.336"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="611.523"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="601.105"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="581.492"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="561.262"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="571.686"
          y="81.3315"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="551.455"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="191.047"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="171.436"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="101.559"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="111.366"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="481.58"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="492.004"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="161.016"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="151.206"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="141.399"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="511.611"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="121.172"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="501.807"
          y="131.593"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="441.736"
          y="211.277"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="441.736"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="221.084"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="230.891"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="240.698"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="251.118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="431.932"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="412.316"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="252.949"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="252.949"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="332.635"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="342.441"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="352.25"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="362.057"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="372.475"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="441.736"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="452.154"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="471.773"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="521.424"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="541.648"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="461.967"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="242.531"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="232.725"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="222.912"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="-8.15851"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="1.6496"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="12.0679"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="21.8749"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="61.7153"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="222.912"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="31.6818"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="41.4911"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="51.9118"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="71.5245"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="81.3338"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="141.402"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="151.209"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="161.018"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="161.018"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="151.209"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="141.402"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="141.402"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="151.209"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="151.209"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="151.209"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="151.209"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="141.402"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="141.402"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="141.402"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="161.018"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="53.7441"
          y="161.018"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="91.7521"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="101.561"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="141.402"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="151.209"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="161.018"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="161.018"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="171.439"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="191.053"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="191.053"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="43.3184"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="181.243"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="171.439"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="171.439"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="161.018"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="171.439"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="171.439"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="171.439"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="171.439"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="171.439"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="161.018"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="151.209"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="141.402"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="111.368"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="121.178"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="131.596"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="3.48047"
          y="141.402"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="151.209"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="191.053"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="33.5137"
          y="191.053"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="191.053"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="191.053"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="191.053"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="191.053"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="3.48047"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="23.7109"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="73.3555"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="83.1621"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="93.582"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="103.393"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="83.1621"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="23.7109"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="103.393"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="103.393"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="93.582"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="83.1621"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="73.3555"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="23.7109"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="13.9004"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="113.199"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="113.199"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="221.086"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="230.893"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="-6.32617"
          y="240.7"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="-6.32617"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="3.48047"
          y="251.121"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="3.48047"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="13.9004"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="23.7109"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="73.3555"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="83.1621"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="93.582"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="103.393"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="113.199"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="113.199"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="103.393"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="93.582"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="83.1621"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="73.3555"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="63.5488"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="53.7441"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="43.3184"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="33.5137"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="23.7109"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="13.9004"
          y="300.77"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="43.3184"
          y="330.805"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="330.805"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="320.384"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="310.577"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="300.77"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="63.5488"
          y="300.77"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="53.7441"
          y="290.963"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="63.5488"
          y="290.963"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="73.3555"
          y="290.963"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="83.1621"
          y="290.963"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="93.582"
          y="290.963"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="103.393"
          y="290.963"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.35"
          x="113.199"
          y="290.963"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="300.77"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="310.577"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="320.384"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="330.805"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="113.199"
          y="330.805"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="330.805"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="83.1621"
          y="340.608"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="93.582"
          y="330.805"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="133.424"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="153.043"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="162.85"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="390.259"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="173.268"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="400.065"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="183.074"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="192.881"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="202.688"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="213.111"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="242.531"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.35"
          x="242.531"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="white"
        />
        <rect
          opacity="0.5"
          x="232.725"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="232.725"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="222.912"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="222.912"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="222.912"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="232.725"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="143.23"
          y="370.643"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="430.099"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="73.3555"
          y="410.483"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="123.006"
          y="420.292"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="262.76"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="450.327"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="272.562"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="282.375"
          y="439.906"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="640.949"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="651.367"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="260.926"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <rect
          opacity="0.5"
          x="661.174"
          y="270.733"
          width="8.1706"
          height="8.1706"
          rx="2"
          fill="#DCC7FC"
        />
        <g className={styles.uptime}>
          <g transform="translate(-94 -102)">
            <Counter />
            <g transform="translate(-86 10)">
              <text
                fill="var(--brand-color-purple-10)"
                fontFamily="var(--font-family-mono)"
                fontSize="16"
                letterSpacing="0.005em"
                x="436.043"
                y="273.1"
              >
                90-DAY UPTIME
              </text>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M575.062 266.963L579.146 262.367L580.87 262.367L584.938 266.963L584.189 267.626L580.506 263.464L580.506 272.633L579.506 272.633L579.506 263.468L575.81 267.627L575.062 266.963Z"
                fill="var(--brand-color-purple-10)"
              />
            </g>
          </g>
        </g>
        <g opacity="0.4" filter="url(#filter0_f_4024_11626)">
          <path
            d="M747 687.107C747 924.59 554.482 1117.11 317 1117.11C79.5176 1117.11 -113 924.59 -113 687.107C-113 449.625 79.5176 257.107 317 257.107C554.482 257.107 747 449.625 747 687.107Z"
            fill="#BD9EFF"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_4024_11626"
          x="-313"
          y="57.1074"
          width="1260"
          height="1260"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="100"
            result="effect1_foregroundBlur_4024_11626"
          />
        </filter>
        <clipPath id="clip0_4024_11626">
          <rect width="662" height="460" fill="white" />
        </clipPath>
      </defs>
    </Explainer>
  );
};

const Counter = () => {
  return (
    <text
      fill="var(--brand-color-purple-10)"
      fontFamily="var(--font-family-mono)"
      fontSize="90"
      letterSpacing="-0.0075em"
      x="261"
      y="371.5"
    >
      <tspan id="ce-counter">0</tspan>
      <tspan>%</tspan>
    </text>
  );
};

export default CompetitiveEdge;
